module.exports = __webpack_public_path__ + "static/media/Rainbow_confident.1155b386.gif";